import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const comsP1Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-1" padding="sm">
    ${node.innerHTML}
  </one-paper>`,
);

export const comsP2Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-2" padding="sm">
    ${node.innerHTML}
  </one-paper>`,
);

export const comsP3Template = (
  node: HTMLElement,
) => unsafeHTML(
  `<one-paper background="legal-3" padding="sm">
    ${node.innerHTML}
  </one-paper>`,
);
